export default __webpack_public_path__ + "static/media/compass-logo-vector.f2bdd874.svg";